import React from "react";
import { Tabs } from "antd";
import "./style.css";

const CustomTab = ({ items, onChange, props }) => {
  return <Tabs items={items} onChange={onChange} {...props} />;
};

export default CustomTab;
